<div class="main-content1">
  <div class="orders-container">
    <div class="title-row">
      <button class="back-btn" (click)="goBack()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
      </button>
      <h2 class="page-title">Your Bookings</h2>
    </div>


    <!-- SKELETON LOADING -->
    <div *ngIf="isLoading" class="bookings-table-container">
      <table class="skeleton-table">
        <thead>
          <tr>
            <th *ngFor="let i of [1,2,3,4,5,6,7,8,9]"><div class="skeleton" style="height: 12px; width: 60px;"></div></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of [1,2,3,4,5]">
            <td><div class="skeleton skeleton-img"></div></td>
            <td>
              <div class="skeleton skeleton-text" style="width: 100px;"></div>
              <div class="skeleton skeleton-text sm"></div>
            </td>
            <td>
              <div class="skeleton skeleton-text"></div>
              <div class="skeleton skeleton-text sm"></div>
            </td>
            <td><div class="skeleton skeleton-badge" style="width: 80px;"></div></td>
            <td><div class="skeleton skeleton-text" style="width: 90px;"></div></td>
            <td><div class="skeleton skeleton-text" style="width: 90px;"></div></td>
            <td><div class="skeleton skeleton-text" style="width: 60px;"></div></td>
            <td><div class="skeleton skeleton-badge"></div></td>
            <td>
              <div style="display: flex; gap: 10px;">
                <div class="skeleton skeleton-btn"></div>
                <div class="skeleton skeleton-btn"></div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>


    <div *ngIf="!isLoading && errorMessage" class="empty-message">
      <p>{{ errorMessage }}</p>
    </div>

    <div *ngIf="!isLoading && bookings.length > 0">
      <div class="search-filter-card">
        <div class="search-input-group">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input
            type="text"
            [(ngModel)]="searchTerm"
            (input)="applyFilter()"
            placeholder="Search equipment..."
          />
        </div>

        <div class="filter-actions">
          <button class="filter-btn" [matMenuTriggerFor]="filterMenu">
            <i class="fa-solid fa-sliders"></i>
            Filters
            <span
              class="filter-count"
              *ngIf="selectedStatus !== 'All' || selectedEquipment !== 'All'"
            ></span>
          </button>

          <mat-menu #filterMenu="matMenu" class="filter-menu-panel">
            <div class="filter-menu-content" (click)="$event.stopPropagation()">
              <div class="filter-header">
                <h3><i class="fa-solid fa-sliders"></i> Filters</h3>
                <button class="clear-all-btn" (click)="resetFilters()">
                  Clear all
                </button>
              </div>

              <div class="filter-section">
                <label>Status</label>
                <div class="chip-grid">
                  <div
                    class="filter-chip"
                    *ngFor="let st of availableStatuses"
                    [class.active]="selectedStatus === st"
                    (click)="selectedStatus = st; applyFilter()"
                  >
                    <i
                      class="fa-solid fa-circle-check"
                      *ngIf="selectedStatus === st"
                    ></i>
                    {{ st === "All" ? "All" : st }}
                  </div>
                </div>
              </div>

              <div class="filter-section">
                <label>Equipment</label>
                <div class="chip-grid">
                  <div
                    class="filter-chip"
                    *ngFor="let eq of availableEquipmentTypes"
                    [class.active]="selectedEquipment === eq"
                    (click)="selectedEquipment = eq; applyFilter()"
                  >
                    <i
                      class="fa-solid fa-circle-check"
                      *ngIf="selectedEquipment === eq"
                    ></i>
                    {{ eq === "All" ? "All" : eq }}
                  </div>
                </div>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="orders-summary-row">
        <p>
          <strong>{{ filteredBookings.length }}</strong> bookings found
        </p>
      </div>

      <!-- TABLE VIEW -->
      <div class="bookings-table-container">
        <table class="bookings-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Booking ID</th>
              <th>Equipment</th>
              <th>Emirate</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let b of paginatedBookings"
              [routerLink]="['/booking-orders', b.id]"
              (click)="b.hasUpdates = false"
            >
              <td>
                <div class="list-img-wrap">
                  <img
                    [src]="b.equipment?.images?.[0] || 'assets/no-image-available.jpg'"
                    alt="Equipment"
                  />
                </div>
              </td>
              <td>
                <span
                  class="booking-id-tag clickable"
                  [routerLink]="['/booking-orders', b.id]"
                  >{{ b.bookingId || "N/A" }}</span
                >
                <div class="booking-date-sm">
                  {{ b.createdAt?.toDate() | date: "dd MMM yyyy" }}
                </div>
              </td>
              <td>
                <div class="eq-info">
                  <span class="eq-name">{{
                    b.equipment?.title || b.equipment?.name
                  }}</span>
                  <span class="eq-brand"
                    >{{ b.equipment?.brand }} {{ b.equipment?.model }}</span
                  >
                </div>
              </td>
              <td>
                <div class="emirate-val">
                  {{ b.equipment?.emirate || "—" }}
                </div>
              </td>
              <td>
                <div class="date-val">
                  {{ b.customer?.startDate?.toDate() | date: "dd MMM yyyy" }}
                </div>
              </td>
              <td>
                <div class="date-val">
                  {{
                    (b.customer?.endDate?.toDate() | date: "dd MMM yyyy") || "—"
                  }}
                </div>
              </td>
              <td>
                <div class="price-info">
                  <span class="amount">AED {{ b.totalAmount | number }}</span>
                </div>
              </td>
              <td>
                <span
                  class="status-badge"
                  [ngClass]="b.status?.toLowerCase() || 'pending'"
                >
                  {{ b.status === 'Rejected' ? 'Unavailable' : (b.status || 'Pending') }}
                </span>
              </td>
              <td>
                <div class="row-actions">
                  <!-- Notification Bell -->
                  <button
                    class="bell-btn"
                    [routerLink]="['/booking-orders', b.id]"
                    (click)="b.hasUpdates = false"
                    [class.ringing]="b.hasUpdates"
                    title="New activity related to this booking"
                  >
                    <i class="fa-solid fa-bell"></i>
                  </button>

                  <!-- View Detail Button -->
                  <button
                    class="detail-row-btn"
                    [routerLink]="['/booking-orders', b.id]"
                    (click)="b.hasUpdates = false"
                  >
                    <i class="fa-solid fa-eye"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- PAGINATOR -->
        <mat-paginator
          [length]="filteredBookings.length"
          [pageSize]="pageSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="onPageChange($event)"
          aria-label="Select page of bookings"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
  <!-- SERVICE CARDS -->
  <!-- <section class="service-cta-section">
    <div class="service-cta-grid">
      <div class="service-card">
        <img src="../../../../assets/landingpage/1.jpg" />
        <div class="overlay"></div>
        <div class="service-content">
          <h2>Is it time to get your vehicle serviced?</h2>
          <button>Book Garage</button>
        </div>
      </div>

      <div class="service-card">
        <img src="../../../../assets/landingpage/2.jpg" />
        <div class="overlay"></div>
        <div class="service-content">
          <h2>Is your vehicle due for passing test?</h2>
          <button>Book Services</button>
        </div>
      </div>

      <div class="service-card">
        <img src="../../../../assets/landingpage/3.jpg" />
        <div class="overlay"></div>
        <div class="service-content">
          <h2>Did your vehicle face a sudden breakdown?</h2>
          <button>Book Tow Truck</button>
        </div>
      </div>
    </div>
  </section> -->

  <!-- BECOME VENDOR -->
  <section class="become_vendor">
    <h1>Want to become a vendor on Aluguloo?</h1>
    <button class="become_btn" (click)="openServiceOfferDialog()">Let's Connect</button>
  </section>
</div>
